import {
  FormField,
  InputTypes,
  PaymentFormField,
  PaymentTypes,
  ValidatorTypes,
} from '@cashier/cashier-model';

import { SchemaCollectorContext } from '../schemaCollector/model';
import { AlternativeAmountConfiguration } from './AlternativeAmountConfiguration';

export const DEFAULT_MIN_AMOUNT = 10;

export const DEFAULT_MAX_AMOUNT_MAP: { [key: string]: number } = {
  [PaymentTypes.Deposit]: 100000,
  [PaymentTypes.Withdrawal]: 4000,
};

const extractValue = (
  field: PaymentFormField,
  context: {
    amounts: string[];
    initialAmount?: string | null;
    paymentType: PaymentTypes;
  },
): string | number | boolean | null => {
  const { initialAmount, amounts, paymentType } = context;

  if (initialAmount === undefined) {
    if (field.value) {
      return field.value;
    }

    if (field.type === InputTypes.Select && field.params?.options?.length) {
      return field.params.options[0].value;
    }

    if (
      amounts.length > 1 &&
      field.name !== 'fiatAmount' &&
      paymentType === PaymentTypes.Deposit
    ) {
      return amounts[1];
    }

    return field.value;
  }

  return initialAmount;
};

export const provideAmountField = (
  field: PaymentFormField,
  context: SchemaCollectorContext,
): FormField => {
  const {
    paymentMethod: { id: paymentMethodId, min, max, step },
    currency,
    isAmountStatic,
    initialAmount,
    paymentType,
  } = context;

  const alternativeAmountDataConfiguration =
    AlternativeAmountConfiguration[paymentMethodId];

  const limit: { min: number; max: number } = alternativeAmountDataConfiguration
    ? {
        min: alternativeAmountDataConfiguration.min,
        max: alternativeAmountDataConfiguration.max,
      }
    : {
        min: min ?? DEFAULT_MIN_AMOUNT,
        max: max ?? DEFAULT_MAX_AMOUNT_MAP[paymentType],
      };

  const params = {
    ...field.params,
    ...limit,
    step: step ?? null,
  };

  if (currency) {
    params.currency = currency;
  }

  return {
    ...field,
    value: extractValue(field, {
      amounts: context.paymentMethod.amounts,
      initialAmount,
      paymentType,
    }),
    isDisabled: isAmountStatic,
    type: field.type === InputTypes.Number ? InputTypes.Text : field.type,
    params,
    validatorType: ValidatorTypes.AMOUNT,
  };
};
